const instances = {};
let u;
export function getInstance(name, options = {}) {
    if (!instances[name]) {
        instances[name] = create(name, options);
    }
    return instances[name];
}
export function get(name) {
    return Promise.resolve(create(name));
}
export function create(name, options = {}) {
    return new S3Uploader(name, options);
}
/**
 * @param {string} name
 */
export function destroy(name) {
    delete instances[name];
}
export function init(app) {
    u = app;
    u.inject('$loader').asImported('s3.uploader');
}
const defaultOptions = {
    endpoint: '',
    subfolder: '',
    viewerHost: '',
    starts_with: [],
    formInputs: {
        acl: '',
        bucket: '',
        key: '',
        Policy: '',
        'X-Amz-Algorithm': '',
        'X-Amz-Credential': '',
        'X-Amz-Date': '',
        'X-Amz-Signature': '',
    }
};
function defaultsDeep(obj, ...args) {
    return u.inject('$helper')
        .defaultsDeep(obj, ...args);
}
class S3Uploader extends Unicorn.mix(class {
}).with(Unicorn.EventMixin) {
    name;
    options;
    constructor(name, options = {}) {
        super();
        this.name = name;
        const awsOptions = u.data('@s3.uploader.' + name) || {};
        this.options = defaultsDeep({}, options, awsOptions, defaultOptions);
    }
    /**
     * Do upload.
     */
    async upload(file, path, options = {}) {
        const fileData = new FormData();
        const inputs = defaultsDeep({}, options.formInputs || {}, this.options.formInputs);
        if (typeof file === 'string') {
            file = new Blob([file], { type: options['Content-Type'] || 'text/plain' });
        }
        if ((file instanceof Blob) || file instanceof File) {
            options['Content-Type'] = options['Content-Type'] || file.type;
        }
        if (options['filename']) {
            options['Content-Disposition'] = 'attachment; filename*=UTF-8\'\'' + encodeURIComponent(options['filename']);
        }
        options['key'] = trimSlashes(this.options.subfolder || '') + '/'
            + trimSlashes(path);
        options['key'] = trimSlashes(options['key']);
        options['Content-Type'] = options['Content-Type'] || undefined;
        options['Content-Disposition'] = options['Content-Disposition'] || undefined;
        // Prepare pre-signed data
        for (let key in inputs) {
            fileData.set(key, inputs[key]);
        }
        // Prepare custom data
        for (let key of Object.keys(this.options.starts_with)) {
            if (options[key]) {
                fileData.set(key, options[key]);
            }
        }
        fileData.append('file', file);
        this.trigger('start', fileData);
        try {
            let res = await u.inject('$http').post(this.options.endpoint || '', fileData, {
                onUploadProgress: (e) => {
                    if (options.onUploadProgress) {
                        options.onUploadProgress(e);
                    }
                    this.trigger('upload-progress', e);
                    if (e.total != null) {
                        this.trigger('progress', e.loaded / e.total, e);
                    }
                }
            });
            const url = this.options.viewerHost + '/'
                + trimSlashes(path);
            this.trigger('success', url, res);
            res.url = url;
            return res;
        }
        finally {
            this.trigger('end');
        }
    }
}
function trimSlashes(str) {
    return str.replace(/^\/+|\/+$/g, '');
}
export { S3Uploader };
